// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aeeaepqrmgsqmeaimnhn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlZWFlcHFybWdzcW1lYWltbmhuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1MzY1NTQsImV4cCI6MjA5MDExMjU1NH0.2HeSXuVV0J8lBRJXen26Erc4nIo4Ksn6dpjov1XVXOQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});